import React from "react";
import { RouteObject } from "react-router-dom";

import { ADMIN_ROUTES } from "../routes";

export const KnowledgeRoutes: RouteObject[] = [
  {
    path: ADMIN_ROUTES.KnowledgeSearch,
    lazy: async () => {
      const { KnowledgeSearchRoute } =
        await import("@src/features/ai/pages/knowledge/KnowledgeSearch.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.KnowledgeSearch}
            adminOnly={true}
            isEnabled={() => true}
            children={KnowledgeSearchRoute}
          />
        ),
      };
    },
  },
  {
    path: ADMIN_ROUTES.KnowledgeDocument,
    lazy: async () => {
      const { KnowledgeDocumentRoute } =
        await import("@src/features/ai/pages/knowledge/KnowledgeDocument.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.KnowledgeDocument}
            adminOnly={true}
            isEnabled={() => true}
            children={KnowledgeDocumentRoute}
          />
        ),
      };
    },
  },
  {
    path: ADMIN_ROUTES.KnowledgeManagement,
    lazy: async () => {
      const { KnowledgeManagementRoute } =
        await import("@src/features/ai/pages/knowledge/KnowledgeManagement.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.KnowledgeManagement}
            adminOnly={true}
            isEnabled={() => true}
            children={KnowledgeManagementRoute}
          />
        ),
      };
    },
  },
];
